import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar } from 'lucide-react';
import { newsEvents } from '../mock';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';

export const NewsEvents = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Page Header */}
      <section className="bg-gradient-to-br from-purple-50 via-white to-purple-50 py-8 md:py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-purple-900 mb-6">News & Events</h1>
            <p className="text-xl text-gray-700 leading-relaxed">
              Stay informed about our latest activities, achievements, community initiatives, and upcoming events
            </p>
          </div>
        </div>
      </section>

      {/* News Grid */}
      <section className="py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {newsEvents.sort((a, b) => new Date(b.date) - new Date(a.date)).map((news, index) => (
              <Card 
                key={news.id} 
                className="group hover:shadow-xl transition-all duration-300 overflow-hidden border-purple-100 hover:border-purple-300 animate-in fade-in slide-in-from-bottom duration-500"
                style={{ animationDelay: `${index * 100 }ms` }}
              >
                <div className="relative h-56 overflow-hidden">
                  <Link to={`/news/${news.id}`}><img                    
                      src={news.thumbnail}
                      alt={news.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    /></Link>
                  <div className="absolute top-4 right-4">
                    <span className="bg-purple-600 text-white px-3 py-1 rounded-full text-xs font-semibold">
                      {news.category}
                    </span>
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                </div>
                <CardContent className="p-6">
                  <div className="flex items-center space-x-2 text-sm text-purple-600 font-medium mb-3">
                    <Calendar size={16} />
                    <span>
                      {new Date(news.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-purple-900 mb-3 line-clamp-2 leading-tight"> <Link to={`/news/${news.id}`}>{news.title}</Link></h3>
                  <p className="text-gray-600 text-sm mb-4 line-clamp-3 leading-relaxed">{news.shortDescription}</p>
                  <Link to={`/news/${news.id}`}>
                    <Button variant="link" className="text-purple-600 hover:text-purple-700 p-0 h-auto font-semibold group/btn">
                      Read Full Story
                      <ArrowRight className="ml-2 group-hover/btn:translate-x-1 transition-transform duration-200" size={16} />
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-gradient-to-br from-purple-50 to-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-2xl mx-auto">
            <h2 className="text-3xl font-bold text-purple-900 mb-4">Join Our Community</h2>
            <p className="text-lg text-gray-700 mb-8">
              Be part of a community that's transforming lives through empowerment, innovation, and collective action
            </p>
            <Link to="/contact">
              <Button className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-6 text-lg rounded-full transition-all duration-200 shadow-lg hover:shadow-xl">
                Get in Touch <ArrowRight className="ml-2" size={20} />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
